import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import CreateCouponsRq from '@domain/rq/coupons/CreateCouponsRq';
import RegisteredCouponRs from '@domain/rs/coupons/RegisteredCouponRs';

const couponsPrefix = '/coupons';

export default interface CouponsRepo {
  //쿠폰 생성
  createCoupons(rq: CreateCouponsRq): Promise<AxiosResponse>;
  //쿠폰 코드 확인
  fetchCouponCheck(couponCode: string): Promise<AxiosResponse<boolean>>;
  //쿠폰 등록
  registerCoupons(couponCode: string): Promise<AxiosResponse>;
  //등록한 쿠폰 목록 조회
  fetchCouponsRegistered(): Promise<AxiosResponse<RegisteredCouponRs>>;
}

export class RemoteCouponsRepo implements CouponsRepo {
  createCoupons(rq: CreateCouponsRq) {
    return axios.post(`${couponsPrefix}`, rq);
  }

  fetchCouponCheck(couponCode: string) {
    return axios.get(`${couponsPrefix}/check`, {
      params: {
        couponCode,
      },
    });
  }

  registerCoupons(couponCode: string) {
    return axios.post(`${couponsPrefix}/register`, null, { params: { couponCode } });
  }

  fetchCouponsRegistered() {
    return axios.get(`${couponsPrefix}/registered`);
  }
}
